// extracted by mini-css-extract-plugin
export default {"rangePicker":"SRangePicker_rangePicker__fOZa8"};